<template>
  <div>
    <div class="d-flex align-center mt-1">
      <v-btn
        small
        text
        :disabled="disabled"
        class="text-none px-1"
        :color="hasValue ? 'blue-grey darken-1' : 'grey'"
        @click="openDialog"
        :style="hasValue ? 'height: auto; min-height: 36px;' : 'height: auto; min-height: 36px; border: 1px dashed #90a4ae; border-radius: 4px;'"
      >
        <div class="d-flex align-start">
          <template v-if="hasValue">
            <v-icon small color="blue-grey lighten-1" class="mr-1 mt-1">account_tree</v-icon>
            <div class="d-flex flex-column align-start p-1">
              <span style="font-size: 12px; line-height: 1.3; color: #90a4ae; white-space: normal; word-break: break-word; max-width: 150px; text-align: left">
                {{ cost_center ? cost_center.name : '—' }}
              </span>
              <span
                class="font-weight-bold"
                style="letter-spacing: normal; font-size: 14px; line-height: 1.4; color: #37474f; white-space: normal; word-break: break-word; max-width: 150px; text-align: left"
              >
                {{ concepto ? concepto.name : '—' }}
              </span>
            </div>
          </template>
          <template v-else>
            <span class="text-caption" :style="inTable ? 'line-height: 1.3' : 'line-height: 1.3; font-size: 0.9rem'">
              <v-icon x-small left>account_tree</v-icon>
              {{ inTable ? 'Centro / Concepto' : 'Seleccione centro y concepto' }}
            </span>
          </template>
        </div>
      </v-btn>

      <v-icon v-if="hasValue && !disabled" x-small color="grey" class="ml-1" style="cursor: pointer" @click="clear">close</v-icon>
    </div>

    <v-dialog v-model="dialog" max-width="500" scrollable>
      <v-card>
        <v-card-title class="py-3 px-4 blue-grey darken-1 white--text">
          <v-icon left color="white">account_tree</v-icon>
          Centro y Concepto
          <v-spacer />
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4 pb-2">
          <v-autocomplete
            v-model="localCostCenter"
            :items="cost_centers"
            item-text="name"
            item-value="id"
            label="Centro de Costo*"
            prepend-inner-icon="place"
            outlined
            dense
            clearable
            return-object
            class="mb-3"
          />
          <v-autocomplete
            v-model="localConcepto"
            :items="sortedConceptos"
            item-text="name"
            item-value="id"
            label="Concepto*"
            prepend-inner-icon="label"
            outlined
            dense
            clearable
            return-object
          />
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="blue-grey darken-1" dark :disabled="!localCostCenter || !localConcepto" @click="confirm">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ConceptoCentroPicker",
  props: {
    concepto: { type: Object, default: null },
    cost_center: { type: Object, default: null },
    conceptos: { type: Array, default: () => [] },
    cost_centers: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    inTable: { type: Boolean, default: false },
  },
  data: () => ({
    dialog: false,
    localConcepto: null,
    localCostCenter: null,
  }),
  computed: {
    hasValue() {
      return this.concepto != null || this.cost_center != null;
    },
    sortedConceptos() {
      return [...this.conceptos].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    },
  },
  methods: {
    openDialog() {
      this.localConcepto = this.concepto ? { ...this.concepto } : null;
      this.localCostCenter = this.cost_center ? { ...this.cost_center } : null;
      this.dialog = true;
    },
    confirm() {
      this.$emit("update:concepto", this.localConcepto);
      this.$emit("update:cost_center", this.localCostCenter);
      this.dialog = false;
    },
    clear() {
      this.$emit("update:concepto", null);
      this.$emit("update:cost_center", null);
    },
  },
};
</script>
